import type { NavigateFunction, NavigateOptions, To } from "react-router-dom";

let _navigate: NavigateFunction | null = null;

/**
 * Register the React Router navigate function.
 * Call this once from a component inside the Router tree (e.g. a NavigationRegistrar).
 */
export const setNavigate = (navigate: NavigateFunction): void => {
  _navigate = navigate;
};

/**
 * Navigate from outside React (e.g. Redux middleware).
 * No-ops silently if navigate has not been registered yet.
 */
export const navigateTo = (to: To, options?: NavigateOptions): void => {
  _navigate?.(to, options);
};
